<template>
  <div>
    <app-heading
      :text="'NBN Tickets Management'"
      :heading="'main'"
    ></app-heading>
    <v-row class="mb-4">
      <v-col
        cols="12"
        md="8"
        lg="9"
        class="pt-0 pb-0"
        :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
      >
        <v-btn
          class="primary"
          @click="createNbnTicket({})"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
        >Create New Ticket</v-btn
        >
      </v-col>
      <v-col cols="12" sm="3" :class="$vuetify.breakpoint.xs ? 'pt-0' : ''">
        <app-search @search="onGridSearch"></app-search>
      </v-col>
    </v-row>
    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      @cellClicked="onRowClicked"
      rowSelection="single"
    ></ag-grid-vue>
    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="nbnDataOptions.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>

    <nbn-ticket-form
      ref="ticketForm"
      :showNewNbnTicket="showNewNbnTicket"
      :fromOrderView="fromOrderView"
      @closeDialog="close()"
    ></nbn-ticket-form>
    <view-nbn-trouble-ticket
      ref="viewNbnTroubleTicket"
      v-bind:viewNbnTroubleTicket="viewNbnTroubleTicket"
      :ticketData="ticketData"
      @close-trouble-ticket="onClose"
    ></view-nbn-trouble-ticket>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "NbnTicketManagement",
  components: {AgGridVue },
  data: () => ({
    isEditing: false,
    statusFilter: -1,
    pageSize: 50,
    keyword: null,
    items: [],
    page: 1,
    showNewNbnTicket:false,
    viewNbnTroubleTicket: false,
    ticketData: {},
    fromOrderView:false,
    paging: {
      pageNo: 1,
      pageSize: 25,
      keyword: "",
    },
    nbnDataOptions:{},
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    gridOptions: {},
    columnDefs: [
    ],
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
    vm.$refs.ticketForm.setWholesaler();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "Ticket ID",
        field: "ticketId",
      },
      {
        headerName: "Reference ID",
        field: "referenceId",
      },
      {
        headerName: "Ticket Type",
        field: "type",
      },
      {
        headerName: "Status",
        field: "status",
      },
      {
        headerName: "User",
        field: "user",
      },
      {
        headerName: "Wholesaler",
        field: "wholesaler",
      },
      {
        headerName: "Raised DateTime",
        field: "raisedTime",
      },
      {
        headerName: "Severity",
        field: "severity",
      }
    ];

    vm.defaultColDef = {
      autoHeight: true
    };
    vm.getTicketsData();
  },
  computed: {
    filteredItems: function () {
      let vm = this;
      return vm.items;
    },
  },
  methods:{
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      let vm = this;
      var payload = {
        "TroubleTicketId":args.data.ticketId
      }
      vm.getTicket(payload)
        .then((data) => {
          vm.viewNbnTroubleTicket = true;
          vm.ticketData = data.data;
        })
        .catch(() => {});
    },
    paginationChange(val){
      let vm = this;
      vm.paging.pageNo = val;
      var search = {
        keyword: null,
        statusFilter: -1,
        pageSize: vm.paging.pageSize,
        pageNumber:vm.paging.pageNo
      };

      if(vm.keyword != nulll && vm.keyword != '')
      {
        search.keyword = vm.keyword;
      }

      vm.getTickets(search)
        .then((data) => {
          vm.items = data.items;
          vm.nbnDataOptions = data;
          vm.gridApi.sizeColumnsToFit();
        })
        .catch(() => {});
    },
    close(){
      let vm = this;
      vm.showNewNbnTicket = false;
    },
    onGridSearch(keyword) {
      let vm = this;

      if (vm.statusFilter === null) vm.statusFilter = -1;

      var search = {
        keyword: null,
        statusFilter: -1,
        pageSize: vm.paging.pageSize,
        pageNumber:vm.paging.pageNo
      };

      if(keyword != null && keyword != '')
      {
        search.keyword = keyword;
      }

      vm.getTickets(search)
        .then((data) => {
          vm.items = data.items;
          vm.nbnDataOptions = data;
          vm.gridApi.sizeColumnsToFit();
        })
        .catch(() => {});

      // vm.setAppointmentSearch({
      //   keyword: vm.keyword,
      //   statusFilter: parseInt(vm.statusFilter),
      //   pageSize: parseInt(vm.pageSize),
      // });
      //
      // var search = {
      //   keyword: keyword,
      //   statusFilter: -1,
      //   pageSize: 50,
      // };
      // clearTimeout(vm._timerId);
      //
      // vm._timerId = setTimeout(() => {
      //   vm.getNbnAppointments(search)
      //     .then((data) => {
      //       vm.items = data.data;
      //       vm.gridApi.sizeColumnsToFit();
      //     })
      //     .catch(() => {});
      // }, 500);
    },
    createNbnTicket(data) {
      let vm = this;
      vm.showNewNbnTicket = true;
      // vm.newOrder = {};
      // vm.setOriginal(false);
      // vm.setEditForm(false);
      // vm.existingOrder = false;
      // vm.setLocationID("");
      // vm.resetFormattedSQResult();
      // vm.setSqResult({});
      // vm.setOrderType("nbn");
      // vm.createOrder(data);
      // if (vm.wholesalers.length === 1) vm.$refs.createOrder.checkLayer();
    },
    getTicketsData() {
      let vm = this;
      var search = {
        keyword: null,
        statusFilter: -1,
        pageSize: vm.paging.pageSize,
        pageNumber: vm.paging.pageNo
      };
      vm.getTickets(search)
        .then((data) => {
          vm.items = data.items;
          vm.nbnDataOptions = data;
          vm.gridApi.sizeColumnsToFit();
        })
        .catch(() => {});
    },
    onClose() {
      let vm = this;
      vm.viewNbnTroubleTicket = false;
      vm.$refs.viewNbnTroubleTicket.viewNbnTroubleTicket = false;
      vm.$refs.viewNbnTroubleTicket.newAppointment = "";
      vm.ticketData = {};
      vm.getTicketsData();
    },
  },
}
</script>

<style scoped>

</style>
